module.exports = "<p-dialog\r\n    id              = 'modal'\r\n    class           = 'spinner-dialog'\r\n    [draggable]     = 'false'\r\n    [closable]      = 'false'\r\n    [responsive]    = 'true'\r\n    [resizable]     = 'false'\r\n    [showHeader]    = 'false'\r\n    [modal]         = 'true'\r\n    [(visible)]     = \"hideUI\"\r\n>\r\n    <div class=\"spinner\"></div>\r\n</p-dialog>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = 1093
// module chunks = 1